export default __webpack_public_path__ + "static/5-4e19470154d280066d5b8741c13bb5e4.jpg";